import { Modal } from "antd";
import moment from "moment";
import pinyin from "js-pinyin";
import { getSearchPartFirstData } from "@/request/api";

let cYear = new Date().getFullYear();
let cMonth = new Date().getMonth() + 1;
let cDate = new Date().getDate();
var num = 0;
//确保中间件关闭的时候只提醒一次
export const errToolTip = () => {
  num++;
  if (num === 1) {
    Modal.info({
      content: "服务程序断开连接，请检查 PYAnalysis 服务控件是否开启",
      width: 465,
      onOk() {
        num = 0;
      },
    });
  }
};

//导联数据调点，在一段数据中挑取最大的值和最小的值，并且确保顺序
export const processingValue = (dataSource) => {
  let len = dataSource.length;
  let max = -32768;
  let min = 32767;
  let max_ind;
  let min_ind;
  for (let i = 0; i < len; i++) {
    if (dataSource[i] > max) {
      max = dataSource[i];
      max_ind = i;
    }
    if (dataSource[i] < min) {
      min = dataSource[i];
      min_ind = i;
    }
  }
  if (max_ind > min_ind) {
    return [min, max];
  } else {
    return [max, min];
  }
};

//判断现在状态是否可以操作
export const fileStatus = (msg) => {
  // 传输状态
  let status =
    msg === "文件上传失败" ||
    msg === "HOLTER文件压缩失败" ||
    msg === "HOLTER文件下载失败" ||
    msg === "文件不存在" ||
    msg === "下载成功" ||
    msg === "上传成功" ||
    msg === "正在打开" ||
    msg === "取消监控成功" ||
    msg === "已报告" ||
    msg === "动态心电文件上传失败" ||
    msg === "请求发生错误" ||
    msg === "录入成功" ||
    msg === "提取成功" ||
    msg === "拷贝失败" ||
    msg === "已报告" ||
    msg === "已审核" ||
    msg === "程序已退出！" ||
    msg === "拷贝成功";
  return status;
};

//判断现在登录账户是什么权限
export const getRolePrivilegeFn = () => {
  const rolePrivilege = JSON.parse(localStorage.getItem("roleList")) || {};
  let PRIVILEGE;
  if (rolePrivilege.indexOf("审核报告") > -1 && rolePrivilege.indexOf("提交报告") > -1) {
    PRIVILEGE = "3";
  } else if (rolePrivilege.indexOf("审核报告") > -1) {
    PRIVILEGE = "1";
  } else if (rolePrivilege.indexOf("提交报告") > -1) {
    PRIVILEGE = "0";
  } else if (rolePrivilege.indexOf("查看报告") > -1) {
    PRIVILEGE = "2";
  } else if (rolePrivilege.indexOf("PDF查看") > -1) {
    PRIVILEGE = "5";
  } else {
    return false;
  }
  return PRIVILEGE;
};

//判断两条线段是否相交，交点坐标是多少
export const segmentsIntr = (a, b, c, d) => {
  // 三角形abc 面积的2倍
  var area_abc = (a.x - c.x) * (b.y - c.y) - (a.y - c.y) * (b.x - c.x);

  // 三角形abd 面积的2倍
  var area_abd = (a.x - d.x) * (b.y - d.y) - (a.y - d.y) * (b.x - d.x);

  // 面积符号相同则两点在线段同侧,不相交 (对点在线段上的情况,本例当作不相交处理);
  if (area_abc * area_abd >= 0) {
    return false;
  }
  // 三角形cda 面积的2倍
  var area_cda = (c.x - a.x) * (d.y - a.y) - (c.y - a.y) * (d.x - a.x);
  // 三角形cdb 面积的2倍
  // 注意: 这里有一个小优化.不需要再用公式计算面积,而是通过已知的三个面积加减得出.
  var area_cdb = area_cda + area_abc - area_abd;
  if (area_cda * area_cdb >= 0) {
    return false;
  }

  //计算交点坐标
  var t = area_cda / (area_abd - area_abc);
  var dx = t * (b.x - a.x),
    dy = t * (b.y - a.y);
  return { x: a.x + dx, y: a.y + dy };
};

//判断心率标志
export const getHeartBeat = (HeartBeat) => {
  switch (HeartBeat) {
    case 0:
      return "N";
    case 4:
      return "S";
    case 1:
      return "V";
    default:
      return "N";
  }
};
//计算心率数值以及位置返回值  [毫秒,心率]
export const computeHeartPosition = (before, after, sampling) => {
  let second = (after - before) / sampling;
  let heart = Math.round(60 / second);
  return [Math.round(second * 1000), heart];
};

//自动刷新
export const refreshTime = (that, callBack) => {
  const settingValues = JSON.parse(localStorage.getItem("settingValues")) || {};
  if (settingValues.refresh === 0) {
    return;
  }
  let time = settingValues.refresh && settingValues.refresh >= 0.1 ? settingValues.refresh : 0.1;
  if (time > 0 && time) {
    refreshList(that, callBack);
  }
  return time;
};
const refreshList = (that, callBack) => {
  if (that.state.percent >= 100) {
    that.setState({
      percent: 0,
    });
    if (callBack) callBack();
  }
  that.setState({
    percent: that.state.percent + 0.5,
  });
};

//设置表头
export const getCommonColumnInfoFn = (oldTable, newTable, type) => {
  let commonColumn = [];
  newTable.forEach((item) => {
    let ele = oldTable.find((ele) => ele.key === item.key);
    if (ele && item.isShow) {
      ele.width = item.width;
      commonColumn.push(ele);
    }
  });
  localStorage.setItem(type, JSON.stringify(newTable));
  return commonColumn;
};

//获取本地设置接收消息类型转化为code
export const getMessageCode = () => {
  const settingData = JSON.parse(localStorage.getItem("settingValues")) || {};
  const msgType = settingData.msgType || ["有新会诊到达消息", "会诊完成消息"];
  let msgCode = "";
  if (msgType.indexOf("有新会诊到达消息") > -1 && msgType.indexOf("会诊完成消息") > -1) {
    msgCode = "3,4,6";
  } else if (msgType.indexOf("有新会诊到达消息") > -1 && msgType.indexOf("会诊完成消息") === -1) {
    msgCode = "3,6";
  } else if (msgType.indexOf("会诊完成消息") > -1 && msgType.indexOf("有新会诊到达消息") === -1) {
    msgCode = "4";
  }
  return msgCode;
};

//输入姓名，自动输入英文姓名
export const handleEnglishName = (e, form) => {
  let name = e.target.value;
  form.setFieldsValue({
    NAME_PHONETIC: pinyin.getFullChars(name),
  });
};

//修改年龄单位 计算出生日期
export const handleChangeAgeUnit = (value, form) => {
  if (value === "岁") {
    let a = cYear - form.getFieldValue("EXAM_AGE");
    if (form.getFieldValue("EXAM_AGE")) {
      form.setFieldsValue({
        BIRTHDAY: moment(a + "-" + cMonth + "-" + cDate),
      });
    }
  }

  if (value === "月") {
    let age = form.getFieldValue("EXAM_AGE");
    let a = null;
    let m = null;
    let b = cMonth - age;

    if (age <= 12) {
      if (b < 0) {
        a = cYear - 1;
        m = 12 + b;
      } else {
        a = cYear;
        m = b;
      }
      if (age) {
        form.setFieldsValue({
          BIRTHDAY: moment(a + "-" + m + "-" + cDate),
        });
      }
    } else {
      let mon = parseInt(age / 12);
      let yu = parseInt(age % 12);
      let bb = cMonth - yu;

      if (bb <= 0) {
        a = cYear - 1 - mon;
        m = 12 + cMonth - yu;
      } else {
        a = cYear - mon;
        m = cMonth - yu;
      }
      if (age) {
        form.setFieldsValue({
          BIRTHDAY: moment(a + "-" + m + "-" + cDate),
        });
      }
    }
  }

  if (value === "天") {
    let m = new Date().getTime();
    let n = form.getFieldValue("EXAM_AGE") * 24 * 3600 * 1000;
    if (form.getFieldValue("EXAM_AGE")) {
      form.setFieldsValue({
        BIRTHDAY: moment(new Date(m - n)),
      });
    }
  }
};

//修改年龄 计算出生日期
export const changeAge = (e, form) => {
  if (form.getFieldValue("AGE_UNIT") === "岁") {
    let a = cYear - e.target.value;
    form.setFieldsValue({
      BIRTHDAY: moment(a + "-" + cMonth + "-" + cDate),
    });
  }

  if (form.getFieldValue("AGE_UNIT") === "月") {
    let a = null;
    let m = null;
    let b = cMonth - e.target.value;

    if (e.target.value <= 12) {
      if (b < 0) {
        a = cYear - 1;
        m = 12 + b;
      } else {
        a = cYear;
        m = b;
      }
      form.setFieldsValue({
        BIRTHDAY: moment(a + "-" + m + "-" + cDate),
      });
    } else {
      // 大于12个月
      let mon = parseInt(e.target.value / 12);
      let yu = parseInt(e.target.value % 12);
      let bb = cMonth - yu;

      if (bb <= 0) {
        a = cYear - 1 - mon;
        m = 12 + cMonth - yu;
      } else {
        a = cYear - mon;
        m = cMonth - yu;
      }
      form.setFieldsValue({
        BIRTHDAY: moment(a + "-" + m + "-" + cDate),
      });
    }
  }

  if (form.getFieldValue("AGE_UNIT") === "天") {
    let m = new Date().getTime();
    let n = e.target.value * 24 * 3600 * 1000;
    form.setFieldsValue({
      BIRTHDAY: moment(new Date(m - n)),
    });
  }
};

//根据出生日期 计算年龄
export const onChangeBirthday = (date, dateString, form) => {
  let realAgeUnit = null;
  let realUnit = "岁";

  let realAgeMonth = null;
  if (new Date().getDate() >= date.format("DD")) {
    realAgeMonth = new Date().getMonth() + 1 - date.format("MM");
  } else {
    realAgeMonth = new Date().getMonth() - date.format("MM");
  }
  let realAge = parseInt(((new Date().getFullYear() - date.format("YYYY")) * 12 + realAgeMonth) / 12); // 岁
  let realMonth = parseInt((new Date().getFullYear() - date.format("YYYY")) * 12 + realAgeMonth); // 月

  if (realMonth < 1) {
    // 小于一个月   天
    realAgeUnit = Math.floor((new Date().getTime() - new Date(dateString).getTime()) / 1000 / 3600 / 24);
    realUnit = "天";
  } else if (realMonth < 12) {
    // 小于12个月 也就是小于一岁  月
    realAgeUnit = realMonth;
    realUnit = "月";
  } else {
    realAgeUnit = realAge;
    realUnit = "岁";
  }

  form.setFieldsValue({
    EXAM_AGE: realAgeUnit,
    AGE_UNIT: realUnit,
  });
};

//获取文件上传/下载/断点续传状态
export const getFileStatus = (data) => {
  let downloadList = "";
  let uploadList = "";
  let arr = [];
  try {
    downloadList = JSON.parse(data.RETURN_RATE);
  } catch (error) {}
  try {
    uploadList = JSON.parse(data.RETURN_MSG);
  } catch (error) {}
  if (typeof uploadList === "object" && typeof downloadList === "object") {
    arr = uploadList.concat(downloadList);
  } else if (typeof uploadList === "object" && typeof downloadList === "string") {
    arr = uploadList;
  } else if (typeof uploadList === "string" && typeof downloadList === "object") {
    arr = downloadList;
  }
  if (arr.length >= 2) {
    for (var i = 0; i < arr.length; i++) {
      for (var j = i + 1; j < arr.length; j++) {
        if ((arr[i] && arr[i].EXAM_UID) === (arr[j] && arr[j].EXAM_UID)) {
          if (moment(arr[i] && arr[i].DATE_TIME) > moment(arr[j] && arr[j].DATE_TIME)) {
            arr.splice(j, 1);
            j = j - 1;
          } else {
            arr.splice(i, 1);
            i = i - 1;
          }
        }
        if (arr[j] && arr[j].EXAM_UID === "") {
          arr.splice(j, 1);
          j = j - 1;
        }
      }
    }
  }
  return arr;
};

//16进制转换为十进制带符号
export const hex2int = (hexStr) => {
  let twoStr = parseInt(hexStr, 16).toString(2); // 将十六转十进制，再转2进制
  let bitNum = 2 * 4; // 1个字节 = 8bit ，0xff 一个 "f"就是4位
  if (twoStr.length < bitNum) {
    while (twoStr.length < bitNum) {
      twoStr = "0" + twoStr;
    }
  }
  if (twoStr.substring(0, 1) === "0") {
    // 正数
    twoStr = parseInt(twoStr, 2); // 二进制转十进制
    return twoStr;
  } else {
    // 负数
    let twoStr_unsign = "";

    twoStr = parseInt(twoStr, 2) - 1; // 补码：(负数)反码+1，符号位不变；相对十进制来说也是 +1，但这里是负数，+1就是绝对值数据-1

    twoStr = twoStr.toString(2);
    twoStr_unsign = twoStr.substring(1, bitNum); // 舍弃首位(符号位)
    // 去除首字符，将0转为1，将1转为0   反码
    twoStr_unsign = twoStr_unsign.replace(/0/g, "z");
    twoStr_unsign = twoStr_unsign.replace(/1/g, "0");
    twoStr_unsign = twoStr_unsign.replace(/z/g, "1");

    twoStr = parseInt(-twoStr_unsign, 2);
    return twoStr;
  }
};

//根据当前登陆医院获取一级分组列表
export const getFirstGroupList = async () => {
  const userInfo = JSON.parse(localStorage.getItem("userInfo")) || { HOSPITAL_CODE: "PLATFORM" };
  let firstGroupList = [];
  let res = await getSearchPartFirstData("E00117", userInfo.HOSPITAL_CODE);
  if (res && res.Status === 1) {
    firstGroupList = res.Result ? res.Result : [];
    return firstGroupList;
  }
};

/**
 * json数组去重
 * @param  {Array} jsonArr 去重之前的数组
 * @param  {String} field  需要去重的字段值
 * @return {Array}        去重之后的数组
 */
export function uniqueJsonArrByField(jsonArr, field) {
  // 数组长度小于2 或 没有指定去重字段 或 不是json格式数据
  if (jsonArr.length < 2 || !field || typeof jsonArr[0] !== "object") return jsonArr;
  const res = new Map(); // 标识对象
  const uniqueArr = jsonArr.filter((item) => !res.has(item[field]) && res.set(item[field], true));
  return uniqueArr;
}

/**
 * 固定合计行
 * @param {*} record
 */
export function fixedTotal(record) {
  // 检索每行数据，包含字段"合计"，返回固定行样式
  if (Object.values(record).indexOf("合计") > -1) {
    const name = "fiexdTr";
    return name;
  }
}

/**存储日志公用方法
 * @param {String} examUId 病人ID(有传，没有传空字符串)
 * @param {String} errorContent 错误日志描述
 * @param {int} requeatType 请求类型0:http或者1:ws
 * @param {Boolean} isAxiosPackage axios请求是否封装true；false
 * 存储在localStorage里的日志格式为[[{},{}],[{},{}],[{},{}]]；内部数组以天为单位，数组内部的对象为一条log对象
 */
export function requestErrorLog(examUId, errorContent, requeatType, isAxiosPackage) {
  if (!window.localStorage) {
    console.log("该浏览器不支持localStorage！");
    return;
  }
  let errorLogList = [],
    errorLogLength = window.g.errorLogLength,
    userInfo = JSON.parse(localStorage.getItem("userInfo")),
    errorDate = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  errorLogList = localStorage.getItem(requeatType === 0 ? "httpErrorLogList" : "wsErrorLogList")
    ? JSON.parse(localStorage.getItem(requeatType === 0 ? "httpErrorLogList" : "wsErrorLogList"))
    : [];
  let logObj = {
    USER_UID: userInfo?.USER_UID || "",
    EXAM_UID: examUId,
    CONTENT: isAxiosPackage ? errorContent + ":" + localStorage.getItem("currentRequestDetailData") : errorContent,
    DATE: errorDate,
    FLAG: 1, //1为错误日志
  };
  //当天有错入日志加一个{},否则加一个[{}]
  if (
    errorLogList.length > 0 &&
    errorLogList[errorLogList.length - 1][0]?.DATE?.slice(0, 10) === errorDate.toString().slice(0, 10)
  ) {
    if (errorLogList.length > 0) {
      errorLogList[errorLogList.length - 1].push(logObj);
    }
  } else {
    if (errorLogList.length === errorLogLength) {
      errorLogList.shift(); //满了删除第一项
    }
    errorLogList.push([logObj]);
  }
  deleteFirstDayLog(requeatType, errorLogList);
}
//存的时候做，如果日志占用太大空间，删掉第一天数据
function deleteFirstDayLog(requeatType, errorLogList) {
  try {
    localStorage.setItem(requeatType === 0 ? "httpErrorLogList" : "wsErrorLogList", JSON.stringify(errorLogList));
  } catch (err) {
    console.log("localStorage存储空间超出最大限制", err);
    errorLogList.shift(); //满了删除第一项
    deleteFirstDayLog(requeatType, errorLogList);
  }
}
